import { IImageProps, Image, ImageFit, ImageLoadState } from '@fluentui/react/lib/Image';

export interface IPImageProps extends IImageProps {}
export { ImageFit as IPImageFit, ImageLoadState as IPImageLoadState };

export const IPImage = (props: IPImageProps) => {
  return <Image {...props} />;
};
